import React, { useContext, useEffect, useState } from "react";
import Modal from "../../components/Modal";
import AddEpisodeType from "./AddEpisodeType";
import { getEpisodeTypes } from "../../apis/episodeType";
import { LanguageContext } from "../../providers/LanguageProvider";
import CommonPagination from "../../components/CommanPagination";
import MastersBreadcrumb from "../../components/MastersBreadcrumb";

const EpisodeTypeList = () => {
  const { translate: t } = useContext(LanguageContext);
  const [episodeTypes, setEpisodeTypes] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>();
  const [isModalOpen, setModalOpen] = useState(false);
  const [editableId, setEditableId] = useState<number | null>(null);

  const fetchEpisodeTypes = (params: any = {}) => {
    getEpisodeTypes(params).then((res: any) => {
      setEpisodeTypes(res.data?.data || res.data || []);
      setMeta(res.data?.meta || null);
    });
  };

  useEffect(() => {
    fetchEpisodeTypes({ per_page: 10 });
  }, []);

  const handleEdit = (id: number) => {
    setEditableId(id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditableId(null);
    setModalOpen(false);
    fetchEpisodeTypes({ per_page: 10 });
  };

  const onPaginationChange = (page: number, pageSize?: number) => {
    fetchEpisodeTypes({ page, per_page: pageSize || 10 });
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <MastersBreadcrumb current="Episode Types" />
      <div className="hidden sm:items-center lg:flex">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Episode Types
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            Manage episode types used for episodes.
          </p>
        </div>
        <div className="flex mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            type="button"
            onClick={() => setModalOpen(true)}
            className="block px-3 py-2 text-sm font-semibold text-center text-white rounded-md shadow-sm bg-primary hover:bg-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            {t("add")}
          </button>
        </div>
      </div>

      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      {t("name")}
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Description
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Meta Fields
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      {t("actions")}
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {episodeTypes.length > 0 ? (
                    episodeTypes.map((type) => (
                      <tr key={type.id}>
                        <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {type.name}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-500">
                          {type.description || "-"}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-500">
                          {Array.isArray(type.metaFields)
                            ? `${type.metaFields.length} fields`
                            : Array.isArray(type.meta)
                            ? `${type.meta.length} fields`
                            : "-"}
                        </td>
                        <td className="py-4 px-3 text-sm font-medium">
                          <button
                            onClick={() => handleEdit(type.id)}
                            className="px-3 py-1.5 text-sm font-semibold text-white rounded-md bg-primary hover:bg-hover"
                          >
                            {t("edit")}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={4}
                        className="py-4 pr-3 pl-4 text-sm font-medium text-gray-900 sm:pl-6"
                      >
                        Record Not Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <Modal
          title={editableId ? "Edit Episode Type" : "Add Episode Type"}
          onClose={handleCloseModal}
          modalContent={
            <AddEpisodeType
              closeModal={handleCloseModal}
              editableId={editableId}
            />
          }
        />
      )}
    </div>
  );
};

export default EpisodeTypeList;
